import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
// Flips a row in or out of the active organization view.
const InStoryToggle = (props) => {
    const title = props.disabled
        ? 'Save first to add this to a story'
        : props.included ? `Remove from "${props.storyTitle}"` : `Show in "${props.storyTitle}"`;
    return _jsx(_Fragment, { children: _jsxs("button", { type: "button", className: `btn btn-sm text-nowrap ${props.included ? 'btn-outline-success' : 'btn-outline-primary'}`, "aria-pressed": props.included, disabled: props.disabled, title: title, onClick: props.onToggle, children: [_jsx("i", { className: `bi ${props.included ? 'bi-check-circle' : 'bi-plus-circle'} me-1`, "aria-hidden": "true" }), "In story"] }) });
};
export default InStoryToggle;
